import styled, {keyframes} from 'styled-components';

const getFromDown = keyframes`
  0%{
    transform: translate(0%,100%) ;
    opacity:0
  }
  90%{
    transform: translate(0%,0%) ;
    opacity:.9
  }
  100%{
    transform: translate(0%,0%) ;
    opacity:.9
  }
`;

export const ForgotPasswordImg = styled.div`
width:62%;
height:100vh;
animation:none;

img{
  width:100%;
  height:100%
  
}`
export const Warper = styled.div`
display: flex;
flex-direction: row;
align-items: center;
justify-content: center;
height: 100vh;
min-width:100%;
display: flex;
color:#000;
`;

export const ForgotDiv = styled.div`
width:38%;
.formContainer{
  border-radius: 0.2rem;
  width:69%;
  margin:0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 87vh;
  justify-content: center;
}
.for-logo{
  display: flex;
  align-items: center;
  justify-content: center;
  height:13vh;
  gap:20%;
}
`;

export const Mask = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: var(--bc-color);
  filter: brightness(15);
  opacity: 0.2;
`;

export const Logo = styled.img`
z-index: 3;
width: 18vw;
margin-bottom: 1.5em;
`;

export const FomrDiv = styled.div`
  z-index: 3;
  width:100%;
`;
export const Title = styled.p`
  font-size: 24px;
  font-weight: bold;
  z-index: 3;
  width: 100%;
  color: #504C33;
  margin: 1.5rem auto 0;
`;

export const Label = styled.label`
  margin: 10px 60px 9px 4px;
  font-size: 14px;
  font-weight: 400;
`;


export const ForgotPassword = styled.a`
cursor: pointer;
  text-align: right;
  font-size: 14px;
  text-decoration:none;
  :hover{
    text-decoration:none;
  }
  :visited{
    text-decoration:none
  }
  margin-bottom: 1rem;
`

export const FlexBox = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
`

